export default "__VITE_ASSET__CHPamPOs__"